module.exports = __webpack_public_path__ + "img/179-Vert Mousse.jpg";